export default __webpack_public_path__ + "static/media/2.c4e27dfa.jpeg";